import { IPageInfo } from '../../models/page.types';
import { ExamTaskGroupSampleSolution } from '../../pages/SampleAssessment/SampleAssessment.types';
import { AssessmentSessionProcessTypeId } from '../exams/assessmentSession/assessments.types';
import { ExamTaskWithoutRequiredComment, SendBackAssessedExamTaskGroupSolutionsResult } from '../scoring/scoring.types';

export enum ExamTaskGroupSolutionAssignmentState {
  AssignedToCurrentUser,
  AssignedToOtherExaminer,
  Unassigned,
}

export interface ExamTaskGroupSampleSolutionsResponse {
  pageInfo: IPageInfo;
  totalCount: number;
  list: ExamTaskGroupSampleSolution[];
}

export interface ExamTaskGroupSolutionScoreStatistic {
  processTypeId: AssessmentSessionProcessTypeId;
  kkProgress: number;
  pzwoProgress: number;
  zwoReady: number;
  total: number;
}

export interface ExamTaskGroupSolutionScoreStats {
  assessmentSessionCloseability: AssessmentSessionCloseability;
  statisticList: ExamTaskGroupSolutionScoreStatistic[];
}

export enum SampleExamTaskGroupSolutionScoreState {
  NotAssessed,
  DuringAssessment,
  DuringChairmanAcceptance,
  ChairmanAccepted,
  Approved,
  Rejected,
}

export enum ApproveExamTaskGroupSolutionScoreResponse {
  InadequateState,
  Success,
  Error,
  CriteriaCommentRequired,
}

export interface SendBackSampleResponse {
  result: ApproveExamTaskGroupSolutionScoreResponse;
  examTaskWithoutRequiredComment: ExamTaskWithoutRequiredComment[];
}

export enum CloseSampleAssessmentSessionResponse {
  SampleAssessmentGroupMemberRequiredSolutionsCountNotMet,
  NoExamTaskGroupSolutionScoreAccepted,
  Error,
  Success,
  ClosedAlready,
}

export enum AssessmentSessionCloseability {
  CanBeClosed,
  ClosedAlready,
  CannotBeClosed,
}

export interface ExamTaskgroupSolutionScoreApprovalCoordinator {
  examTaskGroupSolutionScoreApprovalResultDtos: ExamTaskGroupSolutionScoreApprovalResultDto[];
}

export interface ExamTaskGroupSolutionScoreApprovalResultDto {
  examTaskGroupSolutionId: string;
  examTaskGroupSolutionScoreId: string;
  examinerId: string;
  schoolId: string;
  approveMultipleExamTaskGroupSolutionScoreResponse: CoordinatorApproveExamTaskGroupSolutionScoreResponse;
}

export enum CoordinatorApproveExamTaskGroupSolutionScoreResponse {
  InadequateState,
  WrongProgress,
  Success,
  Error,
}

export interface SendbackAvailable {
  available: boolean;
}
